const I18N_DEFAULT_LANG = "EN";

export { I18N_DEFAULT_LANG };
